export default __webpack_public_path__ + "static/media/wwr-subImg3.5ebf6cc1.webp";